import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
export const defaultFeatureFlags = {
    notifications: {
        enableExternalRecipients: true,
        emailCc: true,
        showPhin: false,
        generateUniqueIdentifier: false,
        additionalStepWizard: false,
    },
};
export const featureFlags = defineSettingMap({
    featureFlags: {
        type: 'json',
        defaultValue: defaultFeatureFlags,
        description: 'Feature Flags',
        group: 'system-admin',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    label: 'Notification Feature Flags',
                    key: 'notifications',
                    children: [
                        { type: 'form.checkbox', key: 'enableExternalRecipients', label: 'Allow Recipient CSV Import' },
                        { type: 'form.checkbox', key: 'emailCc', label: 'Allow CC on Emails' },
                        { type: 'form.checkbox', key: 'showPhin', label: 'Allow PHIN' },
                        {
                            type: 'form.checkbox',
                            key: 'generateUniqueIdentifier',
                            label: 'Generate Unique PHIN Identifier',
                            hidden: { when: '^showPhin', dataEq: 'false' },
                            clearDataOnHide: true,
                        },
                        { type: 'form.checkbox', key: 'additionalStepWizard', label: 'Show Additional Wizard Steps' },
                    ],
                },
            ],
        },
    },
});
